import { render, staticRenderFns } from "./ComparisonDescription.vue?vue&type=template&id=67eac5ec&scoped=true&"
import script from "./ComparisonDescription.vue?vue&type=script&lang=js&"
export * from "./ComparisonDescription.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonDescription.vue?vue&type=style&index=0&id=67eac5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eac5ec",
  null
  
)

export default component.exports